import axios from "axios";
import React, { useContext, useState } from "react";
import { API_CHECKOUT_SAVE, API_BUILDER_CHECKOUT_SAVE, STORE_URL } from "../../api/api";
import CartContext from "../../context/CartContext";
import UserContext from "../../context/UserContext";
import { StoreContext } from "../../context/StoreContext";
import { Box, Button, Typography } from "@mui/material";
import { motion } from "motion/react";

const MotionButton = motion(Button);

const ConfirmButton = ({ setPopup, setError }) => {
  const cartCtx = useContext(CartContext);
  const userCtx = useContext(UserContext);
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;

  const [isSubmitLoading, setIsSubmitLoading] = useState(false);

  const handleConfirmOrderInBuilder = async () => {
    setIsSubmitLoading(true);
    var cartItems = cartCtx.items;
    var newCartItems = [];
    for (var i = 0; i < cartItems.length; i++) {
      var newProduct = {};
      newProduct.product_id = cartItems[i].id;
      newProduct.quantity = cartItems[i].qty;
      newCartItems.push(newProduct);
    }

    var customerAddress = {};
    customerAddress.firstname = userCtx.userInfo.name;
    customerAddress.lastname = userCtx.userInfo.name;
    customerAddress.email = userCtx.userInfo.email;
    customerAddress.telephone = userCtx.userInfo.contact;
    customerAddress.phone = userCtx.userInfo.contact;
    customerAddress.city = userCtx.userInfo.city;
    customerAddress.address = userCtx.userInfo.address;;
    customerAddress.postcode = "postcode";
    customerAddress.address_1 = userCtx.userInfo.location;
    customerAddress.zone_id = userCtx.userInfo.state_id;
    customerAddress.country_id = userCtx.userInfo.country;

    var shippingInfo = {};
    shippingInfo.shipping_method = "free.free";
    shippingInfo.comment = "";

    var paymentInfo = {};
    paymentInfo.payment_method = "qr_payment";
    paymentInfo.agree = 1;
    paymentInfo.comment = "";

    const dataFormat = {
      products: newCartItems,
      address: customerAddress,
      shipping: shippingInfo,
      payment: paymentInfo,
      domain: STORE_URL,
    };

    const mycallback = JSON.stringify(dataFormat);
    await axios
      .post(API_BUILDER_CHECKOUT_SAVE, mycallback, { headers: { 'Content-Type': 'application/json' } })
      .then(function (response) {
        console.log(response.data.message);
        setPopup(true);
      })
      .catch(function (error) {
        setError({
          status: true,
          message: error.message,
        });
      });
    setIsSubmitLoading(false);
  };

  const handleConfirmOrder = async () => {
    setIsSubmitLoading(true);
    var cartItems = cartCtx.items;
    var newCartItems = [];
    for (var i = 0; i < cartItems.length; i++) {
      var newProduct = {};
      newProduct.product_name = cartItems[i].productname;
      newProduct.price = cartItems[i].specialprice
        ? cartItems[i].specialprice
        : cartItems[i].price;
      newProduct.quantity = cartItems[i].qty;
      newProduct.sku = cartItems[i].code;
      newProduct.total =
        parseFloat(
          cartItems[i].specialprice
            ? cartItems[i].specialprice
            : cartItems[i].price
        ) * cartItems[i].qty.toFixed(2);
      newCartItems.push(newProduct);
    }
    const dataFormat = {
      type: "order",
      customer_fname: userCtx.userInfo.name,
      customer_lname: "",
      customer_phone: userCtx.userInfo.contact,
      customer_email: userCtx.userInfo.email,
      customer_address: userCtx.userInfo.address,
      customer_city: userCtx.userInfo.city,
      customer_state: userCtx.userInfo.state,
      product: newCartItems,
    };

    const mycallback = JSON.stringify(dataFormat);
    await axios
      .post(API_CHECKOUT_SAVE, mycallback, { headers: { 'Content-Type': 'application/json' } })
      .then(function (response) {
        console.log("CHECKOUT SAVE URL:", API_CHECKOUT_SAVE);

        console.log(response.data.message);
        setPopup(true);
      })
      .catch(function (error) {
        console.log("CHECKOUT SAVE URL:", API_CHECKOUT_SAVE);

        setError({
          status: true,
          message: error.message,
        });
      });
    setIsSubmitLoading(false);
  };
  const handleClickConfirm = () => {
    const cartTotal = getCartTotal();
    if (cartTotal < 3000) {
      alert("Minimum order amount is ₹3000. Please add more items to your cart.");
      return;
    }
    userCtx.showContactPopup();
  };
  const getCartTotal = () => {
    return cartCtx.items.reduce((acc, cur) => {
      const price = parseFloat(cur.specialprice ? cur.specialprice : cur.price);
      return acc + price * cur.qty;
    }, 0);
  };

  return (
    <Box sx={{ textAlign: 'center' }} className="confri-min">
      <MotionButton
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        variant="contained"
        // onClick={(storeDetails[0].internal_domain && handleConfirmOrderInBuilder) || handleConfirmOrder}
        // onClick={handleClick}
        onClick={handleClickConfirm}

        disabled={isSubmitLoading}
        sx={{
          background: 'linear-gradient(90deg, #FF2200 0%, #FF8C00 100%)',
          color: 'white',
          borderRadius: '25px',
          padding: '12px 30px',
          fontWeight: 'bold',
          fontSize: '1rem',
          textTransform: 'uppercase',
          boxShadow: '0 5px 15px rgba(0, 0, 0, 0.2)',
          margin: '15px auto'
        }}
      >
        CONFIRM ORDERS
      </MotionButton>
      <Typography
        variant="body2"
        sx={{
          color: 'red',
          mt: 2,
          fontWeight: 'bold',
        }}
      >
        Min. Order Amount Rs. 3000
      </Typography>
    </Box>
  );
};

export default ConfirmButton;
